import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { isDefined } from "../../shared/helpers";

export const SPINNER_DISABLE_HEADER = "SPINNER_DISABLE_HEADER";
@Injectable()
export class LoadingService {
  private readonly loading = new BehaviorSubject<boolean>(false);
  public readonly loading$ = this.loading.pipe();

  private count = 0;
  show() {
    this.count++;
    this.loading.next(this.isLoading());
  }

  hide() {
    this.count--;
    if (this.count < 0) {
      this.count = 0; //just some safety
    }
    this.loading.next(this.isLoading());
  }

  private isLoading(): boolean {
    return this.count > 0;
  }
}

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private readonly loader: LoadingService) { }
  /*disableLoadingSpinner  function from moo-shared is not suitable as it has issues with requests that are triggered one after another.
  use case we  have 
    Request 1 => should not show global spinner
    Request 2 should show spinner
    1. we disable the spinner  via disableLoadingSpinner  for request 1 
    2. we trigger Request 2 before Request 1 had  returned (and enabled back the request)
    result Request 2 is ongoing  , user does not know what is happening.   
    
  Aproach  to apply is to disable the spinner for specific Http Request and not globaly.
  
  */

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const spinnercontrolHeaderValue = request.headers.get(SPINNER_DISABLE_HEADER);

    if (isDefined(spinnercontrolHeaderValue)) {
      return this.handleSpinnerHeader(spinnercontrolHeaderValue, request, next);
    } else {
      this.loader.show();
      return next.handle(request).pipe(
        finalize(() => {
          this.loader.hide();
        })
      );
    }
  }

  private handleSpinnerHeader(spinnercontrolHeaderValue: string | null, request: HttpRequest<unknown>, next: HttpHandler) {
    const disableSpinner = spinnercontrolHeaderValue === "true";

    const modifiedReq = request.clone({
      headers: request.headers.delete(SPINNER_DISABLE_HEADER),
    });

    if (!disableSpinner) {
      this.loader.show();
    }

    return next.handle(modifiedReq).pipe(
      finalize(() => {
        if (!disableSpinner) {
          this.loader.hide();
        }
      })
    );
  }
}

